import localforage from 'localforage'
import { Model, Repository, useRepo } from 'pinia-orm'
import Child from '../store/models/Child'
import ScreenTimeEvent from '../store/models/ScreenTimeEvent'
import ImpactReason from '../store/models/ImpactReason'

const MODELS = [Child, ScreenTimeEvent, ImpactReason] as (typeof Model)[] // List of models to be hydrated

const getPiniaPersistedModelData = async (modelName: string) => {
  const modelData = (await localforage.getItem(modelName)) as any

  if (modelData) {
    console.log(`modelData for ${modelName}`, modelData)
    // Convert to array format expected by a Pinia save
    if (!Array.isArray(modelData['data'])) {
      return Object.values(modelData['data'])
    }
  }

  return null
}

export const loadAllPiniaModelData = () => {
  // Load model data from local storage
  MODELS.forEach((model: typeof Model) => {
    const modelName = model.entity

    const modelData = getPiniaPersistedModelData(modelName).then((modelData) => {
      if (modelData) loadPiniaModel(model, modelData)
    })
  })
}

const loadPiniaModel = (model: typeof Model, modelData: any) => {
  // Load model data into the store
  const modelName = model.entity

  // If modelData is provided, insert it into the model repository
  if (modelData.length > 0) {
    try {
      const modelRepo = useRepo(model)

      modelRepo.flush() // Ensure the repo is empty before loading
      const deepCopyModelData = JSON.parse(JSON.stringify(modelData)) // Clone the data to prevent any mutation
      modelRepo.save(deepCopyModelData)

      console.log(`Model data for ${modelName} loaded successfully`)
    } catch (error) {
      console.error(`Failed to load model data for ${modelName}:`, error)
    }
  } else {
    console.log(`No data found for model ${modelName}`)
  }
}
